import styled from "styled-components";

export const PageFilterStyles = styled.div`
    display: flex;
    flex-direction: column;
`;
